import { createContext, useContext } from 'react';

export const AssetContext = createContext(null);

export const useAssetContext = () => {
  return useContext(AssetContext);
};
